import { render } from "./DeutschLuage.vue?vue&type=template&id=7dede7ba&scoped=true"
import script from "./DeutschLuage.vue?vue&type=script&lang=js"
export * from "./DeutschLuage.vue?vue&type=script&lang=js"

import "./DeutschLuage.vue?vue&type=style&index=0&id=7dede7ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dede7ba"]])

export default __exports__